import { render, staticRenderFns } from "./flag.vue?vue&type=template&id=2b48a3c4&scoped=true&"
var script = {}
import style0 from "./flag.vue?vue&type=style&index=0&id=2b48a3c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b48a3c4",
  null
  
)

export default component.exports